import React from 'react';
import { Link } from 'react-router-dom';

import { widgetizeUrl } from '../utils/urls';
import CoreLink from './Link';

export default class WidgetLink extends React.Component {
  static defaultProps = {
    toWidget: true,
  };

  render() {
    // eslint-disable-next-line prefer-const
    let { href, target, isOnWidget, toWidget, component: Component, ...linkProps } = this.props;
    if (isOnWidget) {
      if (toWidget) {
        Component = Component || Link;
        return <Component {...linkProps} to={widgetizeUrl(href)} />;
      }
      target = '_top';
    } else {
      Component = Component || CoreLink;
      return <Component {...linkProps} to={href} />;
    }
    Component = Component || 'a';
    return <Component {...linkProps} href={href} target={target} />;
  }
}
